import { useState, useEffect, useMemo } from 'react';
import { translations } from '../App';

// Hook to get current language and listen for changes
export const useLanguage = () => {
  const [language, setLanguageState] = useState<string>(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('language');
      return saved && ['en', 'te', 'hi', 'ta'].includes(saved) ? saved : 'en';
    }
    return 'en';
  });

  // Listen for language changes from other components
  useEffect(() => {
    const handleLanguageChange = (event: CustomEvent) => {
      const newLanguage = event.detail.language;
      if (newLanguage !== language && ['en', 'te', 'hi', 'ta'].includes(newLanguage)) {
        setLanguageState(newLanguage);
      }
    };
    window.addEventListener('languageChanged', handleLanguageChange as EventListener);
    return () => window.removeEventListener('languageChanged', handleLanguageChange as EventListener);
  }, [language]);

  return language;
};

// Hook to get translations for current language
export const useTranslations = () => {
  const language = useLanguage();
  
  // Use useMemo to ensure translations update when language changes
  return useMemo(() => {
    return translations[language as keyof typeof translations] || translations.en;
  }, [language]);
};

